// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"30db0e97","977":"f5fc0bac"}[chunkId] + ".chunk.js";
};